import { inject, Injectable } from '@angular/core';
import { TrackingEvent } from '../../../../../cross-team-shared/event-tracking/event-utils';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';
import { EventTrackingOptions } from '../../../../../team-apis/core/event-tracking';
import { RootUndoService } from '../../../../shared/misc-services/root-undo.service';

// Can be renamed to PushAndTrackService after objectless cleanup
@Injectable()
export class RootPushAndTrackService {
  private eventTrackingService = inject(EventTrackingService);
  private undoService = inject(RootUndoService);

  pushAndTrack(event: TrackingEvent, options?: EventTrackingOptions) {
    if (this.undoService.pushCurrentState().hasTrackedChanges) {
      this.eventTrackingService.track(event, options);
    }
  }
}
